import request from '@/utils/request'
const url = 'index.php/bazaar/api/bazaar/Login'


//发送验证码
export function SmsCheck(query) {
    return request({
        url: url +'/SmsCheck',
        method: 'get',
        params: query
    })
}
//身份证登录
export function PostSaveByData(query) {
    return request({
        url: url +'/PostSaveByData',
        method: 'get',
        params: query
    })
}


export function GetAutonymInfo(identityCard) {
    return request({
        url: url +'/GetAutonymInfo',
        method: 'get',
        params: {identityCard}
    })
}

//修改个人信息
export function PostModifyByData(query) {
    return request({
        url: url +'/PostModifyByData',
        method: 'get',
        params: query
    })
}


export function PostRegisteredAutonym(autonym_id) {
    return request({
        url: url +'/PostRegisteredAutonym',
        method: 'get',
        params: {autonym_id}
    })
}











